(function() { window.GUID_070a9c12_3257_4289_8e41_601a90c08eba = { getGuid: function() { return "070a9c12-3257-4289-8e41-601a90c08eba"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let SnackbarAnimation;
        (function (SnackbarAnimation) {
            SnackbarAnimation[SnackbarAnimation["Fade"] = 0] = "Fade";
            SnackbarAnimation[SnackbarAnimation["Slide"] = 1] = "Slide";
        })(SnackbarAnimation = Enumeration.SnackbarAnimation || (Enumeration.SnackbarAnimation = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=SnackbarAnimation.pre.js.map
